<template>
  <v-container id="my-contacts" fluid tag="section">

    <v-overlay :value="isOverlayVisible">
      <v-progress-circular :size="70" :width="7" color="green" indeterminate class="spinner" />
    </v-overlay>

    <base-v-component heading="Templates" sub-heading="Manage Templates" />

    <template>

      <v-toolbar flat color="transparent">

        <v-select
          v-model="selectedFilterCategoryId"
          class="filterSelector"
          :items="[{ TemplateCategory: 'All', TemplateCategoryID: -1 }, ...templateCategories]"
          label="Select Filter"
          item-text="TemplateCategory"
          item-value="TemplateCategoryID"
        />

        <v-select
          v-model="selectedFilterType"
          class="filterSelector"
          :items="types"
          label="Select Template Type"
          item-text="typeLabel"
          item-value="value"
        />

        <v-spacer />
        <v-spacer />
        <v-spacer />
        <v-spacer />

        <v-btn v-if="isAdmin" color="primary" dark class="mb-2" @click="addNewTemplate">
          <v-icon small class="mr-2"> mdi-plus </v-icon>
          Add New Template
        </v-btn>

        <template-add-edit-dialog
          :is-visible="isTemplateAddEditDialogVisible"
          :is-edit-mode="isTemplateEditMode"
          :is-copy-mode="isTemplateCopyMode"
          :selected-template="selectedTemplate"
          :templateCategories="templateCategories"
          :templatePlaceholders="templatePlaceholders"
          :allTemplates="allTemplates"
          @on-submit="templateModalActionStart"
          @on-close="hideTemplateModal"
          @on-success="templateModalActionSuccess"
          @on-error="templateModalActionError"
        />

      </v-toolbar>

    </template>

    <v-data-table
      :headers="headers"
      :items="filteredTemplates"
      item-key="cellNumber"
      sort-by="firstName"
    >
      <template v-slot:[`item.isSystemTemplate`]="{ item }">

        <div class="tickerWrapper" v-if="item.isSystemTemplate">
          <div class="systemTemplateTicker">System</div>

          <button v-if="item.templateTypeID !== 3" @click="_copyTemplate(item)">
            <v-icon size="16">mdi-clipboard-text-multiple-outline</v-icon>
          </button>

        </div>

        <div class="tickerWrapper" v-if="!item.isSystemTemplate">
          <div class="userTemplateTicker">Practice</div>
        </div>

      </template>

      <template v-if="isAdmin" v-slot:[`item.actions`]="{ item }">
        <div class="senderActions">
          <div class="commBtnWrapper">
            <v-tooltip v-if="item.templateTypeID === 2" left>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="quick-comm-btn"
                  @click="_showBulkEmailComposer(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-email-edit</v-icon>
                </button>
              </template>
              <span>Compose Email</span>
            </v-tooltip>
            <v-tooltip v-if="item.templateTypeID === 1" left>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="quick-comm-btn"
                  @click="_showBulkMessageComposer(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-message-draw</v-icon>
                </button>
              </template>
              <span>Compose Message</span>
            </v-tooltip>
            <v-tooltip v-if="item.templateTypeID === 3" left>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="quick-comm-btn"
                  @click="_showBulkIvrComposer(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-phone</v-icon>
                </button>
              </template>
              <span>Compose IVR</span>
            </v-tooltip>
          </div>
          <v-btn
            v-if="!item.isSystemTemplate"
            color="primary"
            outlined
            x-small
            @click="editTemplate(item)"
          >
            Edit
          </v-btn>
          &nbsp;

          <v-icon v-if="!item.isSystemTemplate" small @click="deleteTemplate(item)">
            mdi-delete
          </v-icon>
        </div>
      </template>
      <template v-slot:no-data>
        <p class="mb-4 mt-4">No templates to display</p>
        <v-btn color="primary" outlined class="mb-4" @click="_initiateLoad">
          Refresh
        </v-btn>
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <div class="py-3" />
  </v-container>
</template>

<script>
  /* eslint-disable */
import { VueMaskDirective } from "v-mask";
import Vue from "vue";
import { ApiCalls } from "../../../../api-calls";
import UserHelper from "../../../../utils/user-helper";
import HelperMethods from "../../../../utils/helper-methods";
import EventEmitter from "../../../../utils/event-emitter";

Vue.directive("mask", VueMaskDirective);

export default {
  components: {
    TemplateAddEditDialog: () => import("../../components/template-add-edit-dialog/template-add-edit-dialog")
  },
  data: () => ({
    dialog: false,
    headers: [
      { text: "Name", value: "Name" },
      // { text: "Body", value: "templateBody" },
      { text: "Description", value: "Description" },
      { text: "Category", value: "templateCategory" },
      { text: "Template Type", value: "templateType" },
      { text: "", value: "isSystemTemplate" }
    ],
    types: [
      {
        typeLabel: "All",
        value: "all"
      },
      {
        typeLabel: "Practice templates",
        value: "user"
      },
      {
        typeLabel: "System templates",
        value: "system"
      }
    ],
    snackbar: false,
    notification: "Unknown",
    isOverlayVisible: false,
    allTemplates: [],
    filteredTemplates: [],
    templateCategories: [],
    templateTypes: [],
    templatePlaceholders: [],
    selectedFilterCategoryId: -1,
    isTemplateAddEditDialogVisible: false,
    isTemplateEditMode: false,
    isAdmin: false,
    isTemplateCopyMode: false,
    selectedFilterType: "all"
  }),

  watch: {
    selectedFilterCategoryId() {
      this._filterTemplates();
    },
    selectedFilterType() {
      this._filterTemplates();
    },
    '$store.state.posActivePractice': function () {
      this._initiateLoad();
    },
  },

  created() {
    this.isAdmin = UserHelper.checkIfHasPracticeAdminAccess();
    if (this.isAdmin) {
      this.headers.push({ text: "Actions", value: "actions", sortable: false });
    }
    this._initiateLoad();
  },

  methods: {
    _formatPromiseAllSettledResponses(allResponses) {
      return allResponses.map(response => ({
        ...response,
        value: response.value ? response.value : { data: [] }
      }));
    },
    async _initiateLoad() {
      await HelperMethods.sleepTime(400);
      try {
        if (this.$store.state.posActivePractice.value) {
          this.isOverlayVisible = true;
          let responses = await Promise.allSettled([
            ApiCalls.fetchTemplates(0, this.$store.state.posActivePractice.value),
            ApiCalls.fetchTemplateCategories(),
            ApiCalls.fetchTemplateTypes(),
            ApiCalls.fetchTemplatePlaceholders(),
            ApiCalls.fetchSystemTemplates(1, 0),
            ApiCalls.fetchSystemTemplates(2, 0),
            ApiCalls.fetchIvrTemplates()
          ]);
          responses = this._formatPromiseAllSettledResponses(responses);
          const allTemplates =
            responses[0].value.data && responses[0].value.data.length ? responses[0].value.data : [];
          let allSystemSMSTemplates =
            responses[4].value.data && responses[4].value.data.length ? responses[4].value.data : [];
  
          allSystemSMSTemplates = allSystemSMSTemplates.map(template => ({
            ...template,
            isSystemTemplate: true
          }));
  
          let allSystemEmailTemplates =
            responses[5].value.data && responses[5].value.data.length ? responses[5].value.data : [];
  
          allSystemEmailTemplates = allSystemEmailTemplates.map(template => ({
            ...template,
            isSystemTemplate: true
          }));
  
          let allSystemIvrTemplates =
            responses[6].value.data && responses[6].value.data.length ? responses[6].value.data : [];
  
          allSystemIvrTemplates = allSystemIvrTemplates.map(template => ({
            ...template,
            isSystemTemplate: true
          }));
  
          this.templateCategories = responses[1].value.data;
          const idMappedTemplateCategories = {};
          this.templateCategories.forEach(c => {
            idMappedTemplateCategories[c.TemplateCategoryID] = c.TemplateCategory;
          });
          this.templateTypes = responses[2].value.data;
          this.templatePlaceholders = responses[3].value.data ? responses[3].value.data : [];
          this.allTemplates = [
            ...allTemplates,
            ...allSystemSMSTemplates,
            ...allSystemEmailTemplates,
            ...allSystemIvrTemplates
          ].map((t) => {
            let templateType = "";
            if (t.TemplateTypeID === 1) {
              templateType = "SMS Template";
            } else if (t.TemplateTypeID === 2) {
              templateType = "Email Template";
            } else if (t.TemplateTypeID === 3) {
              templateType = "Ivr Template";
            }
            return {
              ...t,
              templateType,
              templateCategory: idMappedTemplateCategories[t.TemplateCategoryID]
            };
          });
          console.log("this.allTemplates", this.allTemplates);
          this._filterTemplates();
        }
      } catch (error) {
        console.log("error :>> ", error);
        this.allTemplates = [];
        this.snackbar = true;
      }
      this.isOverlayVisible = false;
    },

    _filterTemplates() {
      this.filteredTemplates = Object.assign([], this.allTemplates);
      // Filter by category
      if (this.selectedFilterCategoryId && this.selectedFilterCategoryId > -1) {
        // Filter
        this.filteredTemplates = this.filteredTemplates.filter(
          t => t.templateCategoryID === this.selectedFilterCategoryId
        );
      }
      // Filter by template type
      if (this.selectedFilterType && this.selectedFilterType !== "all") {
        // Filter
        this.filteredTemplates = this.filteredTemplates.filter(t => (this.selectedFilterType === "system" ? t.isSystemTemplate : !t.isSystemTemplate));
      }
    },

    addNewTemplate() {
      this.isTemplateCopyMode = false;
      this.isTemplateEditMode = false;
      this.isTemplateAddEditDialogVisible = true;
    },

    templateModalActionStart() {
      this.isOverlayVisible = true;
    },

    async templateModalActionSuccess() {
      this.hideTemplateModal();
      await this._initiateLoad();
      this.isOverlayVisible = false;
    },

    hideTemplateModal() {
      this.isTemplateAddEditDialogVisible = false;
    },

    editTemplate(selectedTemplate) {
      this.isTemplateCopyMode = false;
      this.selectedTemplate = selectedTemplate;
      this.isTemplateAddEditDialogVisible = true;
      this.isTemplateEditMode = true;
    },

    templateModalActionError(error) {
      this.isOverlayVisible = false;
      this.notification = "Server error";
      this.snackbar = true;
      throw error;
    },

    async deleteTemplate(template) {
      if (window.confirm(`Are you sure you want to delete ${template.name}? `)) {
        this.isOverlayVisible = true;
        try {
          await ApiCalls.deleteTemplate(template.templateID);
          await this._initiateLoad();
          this.notification = "Deleted template";
          this.snackbar = true;
        } catch (error) {
          this.notification = "Unable to delete";
          this.snackbar = true;
        }
        this.isOverlayVisible = false;
      }
    },
    _showBulkMessageComposer(template) {
      EventEmitter.dispatch("show-group-bulk-sms-composer", {
        selectedTemplate: template
      });
    },
    _showBulkIvrComposer(template) {
      EventEmitter.dispatch("show-group-bulk-ivr-composer", {
        selectedTemplate: template
      });
    },
    _showBulkEmailComposer(template) {
      EventEmitter.dispatch("show-group-bulk-email-composer", {
        selectedTemplate: template
      });
    },
    _copyTemplate(item) {
      this.isTemplateCopyMode = true;
      this.isTemplateEditMode = false;
      this.isTemplateAddEditDialogVisible = true;
      this.selectedTemplate = item;
    }
  }
};
</script>
<style scoped lang="scss">
.v-overlay.v-overlay--active.theme--dark {
  z-index: 300 !important;
}
.spinner {
  margin-left: 17rem;
}
@media only screen and (max-width: 968px) {
  .spinner {
    margin-left: 0;
  }
}
.senderActions {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.commBtnWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.quick-comm-btn {
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  margin-right: 15px;
  align-items: center;
  background-color: rgb(0, 114, 44);
  box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.12);
  color: white;
  font-size: 12px;
  * {
    font-size: 12px;
    color: white;
  }
  border-radius: 100px;
}
.systemTemplateTicker {
  background-color: chocolate;
  border-radius: 25px;
  padding: 2px 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-align: center;
  color: white;
}
.userTemplateTicker {
  background-color: rgb(30, 144, 210);
  border-radius: 25px;
  padding: 2px 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-align: center;
  color: white;
}
.tickerWrapper {
  display: flex;
  button {
    font-size: 0.6rem;
    margin-left: 15px;
    cursor: pointer;
  }
}
.filterSelector {
  margin-right: 1rem;
}
</style>
